import service from './request'
import md5 from 'js-md5';
import util from '@/util/util.js'

// Index 新闻模块接口
export const GetNews = data => {
    return service({
        url: `/news/group?channelNames=${data.channelNames}&showRowCount=${data.showRowCount}`,
        method: 'get',
    })
}

// 新闻模块更多接口
export const GetNewsMore = data => {
    return service({
        url: `/news/more?channelName=${data.channelName}&pageSize=${data.pageSize}&pageNum=${data.pageNum}`,
        method: 'get',
    })
}


//  获取文章详情
export const getArticlesInfo = articlesId => {
    return service({
        url: `/news/${articlesId}`,
        method: 'get',
    })
}

//  实践案例
export const getCaseList = data => {
    var url
    if (data.sdgId) {
        url = `/news/case?channelName=${data.channelName}&showRowCount=${data.showRowCount}&sdgId=${data.sdgId}`
    } else {
        url = `/news/case?channelName=${data.channelName}&showRowCount=${data.showRowCount}`
    }

    return service({
        url: url,
        method: 'get',
    })
}








//数据共享菜单
export const topDatasets = data => {
    return service({
        url: '/image/topDatasets',
        method: 'get',
    })
}

//   返回三级全部数据
export const thirdDatasets = data => {
    return service({
        url: `/image/thirdDatasets?datasetId=${data.dataId}&pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'get',
    })
}

// 地球大数据共享平台数据检索
export const fullSearch = data => {
    return service({
        url: `/image/fullSearch?keywords=${data}`,
        method: 'get'
    })
}

// 获取邮箱code
export const CodeByEmail = data => {
    return service({
        url: `system/getActiveCodeByEmail?email=${data}`,
        method: 'get',
    })
}

// 校验邮箱
export const emailIsExist = data => {
    return service({
        url: `system/emailIsExist?email=${data}`,
        method: 'get',
    })
}
//用户注册
export const signup = data => {
    return service({
        url: 'system/signup',
        method: 'post',
        data: {
            "loginName": data.loginName,
            "password": data.password,
            "confirmPassword": data.confirmPassword,
            "email": data.email,
            "activeCode": data.activeCode,
        }
    })
}

// 用户登录
export const userLogin = data => {
    return service({
        url: `${util.ssoApi}/system/userLogin`,
        method: 'post',
        data: {
            loginName: data.loginName,
            password: md5(data.password),
        }
    })
}

// 校验token是否正确
export const checkJwt = data => {
    return service({
        url: `${util.ssoApi}/checkJwt?token=${data}`,
        method: 'get',
    })
}


// 用户退出
export const logout = data => {
    return service({
        url: `${util.ssoApi}/system/logout`,
        method: 'get',

    })
}

export const updatePassword = data => { //忘记密码
    return service({
        url: `${util.ssoApi}/system/user/forgetPassword`,
        method: 'post',
        data: {
            loginName: data.loginName,
            email: data.email,
            password: data.password,
            confirmPassword: data.confirmPassword,
            activeCode: data.activeCode
        }
    })
}

export const EmailCode = email => { //获取验证码
    return service({
        url: `${util.ssoApi}/system/user/getActiveCodeByEmail?email=${email}`,
        method: 'get',
    })
}

export const checkLoginNameUnique = data => { //校验用户名
    return service({
        url: `${util.ssoApi}/system/user/checkLoginNameUnique?loginName=${data}`,
        method: 'get',
    })
}

export const checkEmailUnique = data => { //校验邮箱
    return service({
        url: `${util.ssoApi}/system/user/checkEmailUnique?email=${data}`,
        method: 'get',
    })
}


export const Signup = data => { //注册
    return service({
        url: `${util.ssoApi}/system/register`,
        method: 'post',
        data: {
            loginName: data.loginName,
            email: data.email,
            password: data.password,
            confirmPassword: data.confirmPassword,
            activeCode: data.activeCode

        }
    })
}
// 获取产品共享平台数据列表
export const Datalist = data => {
    return service({
        url: `/image/shareDataFile?pageNum=${data.pageNum}&pageSize=${data.pageSize}&dataset=${data.dataset}`,
        method: 'get',
    })
}


// 大屏

//张家口天气查询
export const getWeather = data => {
    return service({
        url: `/image/getWeather?cityId=101090301&cityName=zhangjiakou`,
        method: 'get',
    })
}

//张家口新闻查询
export const getZjkNews = data => {
    return service({
        url: `/image/getZjkNews`,
        method: 'get',
    })
}

// 2.23张家口数据查询
export const getZjkData = data => {
    return service({
        url: `/image/getZjkData`,
        method: 'get',
    })
}

// 张家口条件检索
export const getZjkDataConditions = data => {
    return service({
        url: `/image/getZjkDataConditions`,
        method: 'post',
        data: {
            locationId: data.locationId,
            extent: data.extent,
            classifyId: data.classifyId,
            startTime: data.startTime,
            endTime: data.endTime
        }
    })
}


// 新闻模块
export const newsAbstract = data => {
    return service({
        url: `/news/single/summary?channelCode=${data.channelName}&showRowCount=${data.showRowCount}`,
        method: 'get'
    })
}

// 新闻详情
export const newsDetail = data => {
    return service({
        url: `/news/newsDetail?newsId=${data}`,
        method: 'get'
    })
}

//更多新闻
export const More = (data, pageNum) => {
    return service({
        url: `/news/more?channelCode=${data}&pageSize=20&pageNum=${pageNum}`,
        method: 'get'
    })
}



// 数字一带一路检索与可视化产品分类
export const ProductLists = data => {
    return service({
        url: `/image/thirdSelects`,
        method: 'get',
    })
}

// second options
export const SecondDatasets = data => {
    return service({
        url: `/image/thirdDatasets?datasetId=${data.dataId}`,
        method: 'get',
    })
}


//数据检索
export const CalculateDataFile = data => {
    console.log(data)
    return service({
        url: `/image/calculateDataFile`,
        method: 'post',
        data: {
            dataset: data.dataset,
            polygon: data.polygon,
            time: data.time,
            pageNum: data.pageNum,
            pageSize: data.pageSize ? data.pageSize : 4
        }
    })
}


// 数据收藏（购物车）
export const addShoppingCart = data => {
    return service({
        url: `/image/addShoppingCart`,
        method: 'post',
        data
    })
}

//订单查询列表
export const OrderList = data => {
    return service({
        url: `file/orderList?pageSize=${data.pageSize}&pageNum=${data.pageNum}&orderType=${data.orderType}`,
        method: 'get'
    })
}

// 数据收藏列表
export const shoppingCartList = data => {
    return service({
        url: `/image/shoppingCartList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'get',
    })


}

// 数据收藏删除（购物车）
export const deleteShoppingCart = data => {
    return service({
        url: `/image/deleteShoppingCart`,
        method: 'post',
        data
    })
}


// 数据预定
export const getReservation = data => {
    return service({
        url: `/file/placeOrder`,
        method: 'post',
        data: {
            ds: data.ds,
            ids: data.ids,
            cids: data.cids
        }
    })
}

// 数据准备
export const DataPrepare = data => {
    return service({
        url: `/file/dataPrepare`,
        method: 'post',
        data: {
            orderId: data,
        }
    })
}

//WMS资源检索
export const getWms = data => {
    return service({
        url: `/image/wmsList`,
        method: 'get',
    })
}

//Tiff图片 产品列表
export const productComsiteList = data => {
    return service({
        url: `/image/productCompositeList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'get',
    })
}

//基于图的影像分割算法（GBS）
export const gbsSegmentationAlgorithm = data => {
    return service({
        url: `/image/gbsSegmentationAlgorithm`,
        method: 'post',
        data: {
            bandsList: data.bandsList,
            inputPath: data.inputPath,
            productName: data.productName,
            sigma: data.sigma,
            c: data.c,
            minSize: data.minSize,
            tileSize: data.tileSize,
            numPartitions: data.numPartitions
        }
    })
}

//5.8基于图的图像多尺度分割算法（Mrs）
export const mrsSegmentationAlgorithm = data => {
    return service({
        url: `/image/mrsSegmentationAlgorithm`,
        method: 'post',
        data: {
            bandsList: data.bandsList,
            inputPath: data.inputPath,
            productName: data.productName,
            scale: data.scale,
            wband: data.wband,
            wcolor: data.wcolor,
            wcmpt: data.wcmpt,
            tileSize: data.tileSize,
            squareSize: data.squareSize,
            numPartitions: data.numPartitions
        }
    })
}

//5.11 影像剪裁 
export const imageTailor = data => {
    return service({
        url: `/image/imageTailor`,
        method: 'post',
        data: {
            bandList: data.bandList,
            polygonStr: data.polygonStr,
            // bandType:data.bandType,
            polygonCrs: 'LatLng',
            productName: data.productName,
            dataset: data.dataset,
            filePath: data.filePath
        }
    })
}

//用户session
export const sessionId = data => {
    return service({
        url: '/system/sessionId',
        method: 'get',
    })
}

// DEM 产品合成
export const demSingleSceneCal = data => {
    return service({
        url: `/image/demSingleSceneCal`,
        method: 'post',
        data: {
            imagePath: data.imagePath,
            method: data.productMethod,
            productName: data.productName,
        }
    })
}

// 单景产品合成
export const landsatSingleSceneCal = data => {
    return service({
        url: `/image/landsatSingleSceneCal`,
        method: 'post',
        data: JSON.stringify(data)

    })
}

// 获取数据详情
export const getDetailedInfo = data => {
    return service({
        url: `/image/detailedInfo?dataset=${data}`,
        method: 'get'
    })
}




// 获取数据详情
export const operationLog = data => {
    return service({
        url: `/system/operationLog/list`,
        method: 'get'
    })
}


// 记录埋点
export const pageView = data => {
    return service({
        url: `/pageView/incr?page=${data}`,
        method: 'get'
    })
}




/* SDG数据共享 模块 */

export const shareSDGList = data => {
    return service({
        url: `/sdg/target/list`,
        method: 'get'
    })
}




/* SDG指标体系模块接口 */
/* 获取目标列表 */
export const goalList = id => {
    return service({
        url: `/sdg/goal/list`,
        method: 'get'
    })
}

/* 目标下面的指标体系 */
export const targetList = id => {
    return service({
        url: `/sdg/index/list?id=1`,
        method: 'get'
    })
}

/* 获取SDG数据下面指标数据 */
export const indicatorList = id => {
    return service({
        url: `/sdg/index/list?goalId=${id}`,
        method: 'get'
    })
}
/* 获取指标数据 */
export const indicator = id => {
    return service({
        url: `/sdg/index/${id}`,
        method: 'get'
    })
}

/* 获取SDG视频 */
export const video = data => {
    return service({
        url: `/file/list/goal/${data}`,
        method: 'get'
    })
}


